import { useRouter } from 'next/router'
import { useCallback, useMemo, memo } from 'react'
import { useTheme } from 'styled-components'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { useIsTabletS, useIsLaptopL } from '@hooks/use-media-query'

import { CaseButton } from './CaseButton'
import { CaseHeader } from './CaseHeader'
import { CaseTechStack } from './CaseTechStack'
import { Wrapper, Container, Overlay } from './styles'

function CaseComponent({
  image: { src, title, alt, mobileSrc, laptopSrc },
  header,
  techStack,
  link,
  button,
  hover = false,
  notOverlay = false,
  removeOverlay = false,
  gap,
}) {
  const router = useRouter()
  const theme = useTheme()

  const handleClick = useCallback(() => {
    router.push(link)
  }, [link, router])

  const isAboveTabletS = useIsTabletS()
  const isAboveLaptopL = useIsLaptopL()

  const imageSrc = useMemo(() => {
    if (isAboveLaptopL && laptopSrc) {
      return laptopSrc
    }
    if (!isAboveTabletS && mobileSrc) {
      return mobileSrc
    }
    return src
  }, [isAboveLaptopL, isAboveTabletS])

  return (
    <Wrapper as="a" href={link} hover={hover}>
      <ImageWithPlaceholder
        src={imageSrc}
        title={title}
        alt={alt}
        fill
        sizes={100}
      />
      <Container spacing={gap?.(theme)}>
        <CaseHeader {...header} />
        <CaseTechStack {...techStack} />
        <CaseButton onClick={handleClick} {...button} />
      </Container>
      {removeOverlay ? null : (
        <Overlay textColor={header.titleColor} notOverlay={notOverlay} />
      )}
    </Wrapper>
  )
}

const Case = memo(CaseComponent)

export default Case
